import { PayloadAction } from "@reduxjs/toolkit";
import { editorInterface } from "../slice/editor";

/**
 * Function to update the layout configuration state within the editor.
 *
 * Updates the state of loadInPageMultimgEditor with the new configuration provided by the action payload.
 */
export const updateLayouts = (state: editorInterface, action: PayloadAction<editorInterface["loadInPageMultimgEditor"]>) => {
  state.loadInPageMultimgEditor = action.payload;
};

/**
 * Updates the selected layout in the editor state.
 *
 * This function takes the current state and an action, and sets the selected layout
 * in the editor state to the payload of the action.
 */
export const updateSelectedLayout = (state: editorInterface, action: PayloadAction<editorInterface["selectedLayout"]>) => {
  state.qrCode = false
  state.selectedLayout = action.payload;
};

/**
 * Updates the scale layout within the editor state.
 *
 */
export const updateScaleLayout = (state: editorInterface, action: PayloadAction<editorInterface["scale"]>) => {
  if(state.scale !== action.payload) {
    state.scale = action.payload};
};

export const updateIsLoading = (state: editorInterface, action: PayloadAction<editorInterface["isLoading"]>) => {
    state.isLoading = action.payload;
};

/**
 * Updates the selected background in the application's state based on the provided action payload.
 *
 */
export const updateSelectedBackground = (state, action) => {
  const {value, type, orientation, index} = action.payload
  const cleanValue = value.replace(process.env.PREFIX_URL || '', '');

  let saveValue;

  switch (type) {
    case "base":
      saveValue = `${process.env.PREFIX_URL}${cleanValue}`;
      break;
    case "image":
      saveValue = cleanValue.includes('.gif') ? `${process.env.PREFIX_URL}${cleanValue}` : `${process.env.PREFIX_URL}/v2017/html2canvas/proximg.php?img=/assets/v2017/layout-carte-bg/${cleanValue}_${orientation}_print.gif`;
      break;
    case "color":
      saveValue = cleanValue;
      break;
    case "gradient":
      saveValue = `linear-gradient(${cleanValue})`;
      break;
    default:
      saveValue = "";
  }

  state.selectedBackground[orientation].type = type;
  state.selectedBackground[orientation].value = saveValue;
  state.selectedBackground.index = index;
}

/**
 * Checks and sets the "isTooBig" property of a text element in the current data state.
 *
 * This function searches through the current data elements in the state to find
 * an element of type "txt" that matches the provided key. If such an element is found,
 * it updates its "isTooBig" property based on the given value.
 */
export const isTextTooBig = (state, action) => {
  const {key, value} = action.payload

  const element = state.currentData.find((element) => element.type === "txt" && element.textCardIndex === key.current);
  element.isTooBig = value;
}